// extracted by mini-css-extract-plugin
export default {"shareOverlayContainer":"Bx3juQ","shareTitle":"JLRKNI","modeSelect":"OerdnL","socialButtons":"zicPOj","linkCopied":"EVCc_k","shown":"_0v4sQ","linkCopiedIcon":"c0jRT4"};